import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const Link = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={
          props.variant === "line"
            ? "M18.673 12.34a4.963 4.963 0 0 0-7.144-6.887L9.434 7.548l-.056.063a.667.667 0 0 0 .999.88l2.094-2.095.12-.115a3.63 3.63 0 0 1 5.013 5.248l-2.095 2.094-.055.063a.667.667 0 0 0 .998.88l2.095-2.095.126-.13Zm-3.535-3.478c.24.24.259.618.056.88l-.056.063-5.333 5.333a.667.667 0 0 1-.999-.88l.056-.063 5.333-5.333c.26-.26.683-.26.943 0Zm-6.647.572c.24.24.259.618.055.88l-.055.063-2.095 2.094a3.63 3.63 0 0 0 5.013 5.248l.12-.115 2.094-2.095a.667.667 0 0 1 .998.88l-.055.063-2.095 2.095a4.963 4.963 0 0 1-7.144-6.887l.126-.131 2.095-2.095c.26-.26.682-.26.943 0Z"
            : "M11.293 5.492a5.108 5.108 0 0 1 7.215 0 5.109 5.109 0 0 1 0 7.216l-2.193 2.193-1.415-1.414 2.193-2.194a3.105 3.105 0 0 0 0-4.386A3.093 3.093 0 0 0 14.9 6c-.794 0-1.588.302-2.193.907L10.514 9.1 9.099 7.685l2.194-2.193Zm-2.334 9.55a.997.997 0 0 0 1.414 0l4.668-4.669a1 1 0 1 0-1.414-1.414l-4.668 4.668a1 1 0 0 0 0 1.414Zm2.334 2.051a3.105 3.105 0 0 1-4.387 0 3.105 3.105 0 0 1 0-4.386l2.193-2.193L7.685 9.1l-2.193 2.193a5.108 5.108 0 0 0 0 7.216A5.089 5.089 0 0 0 9.1 20a5.084 5.084 0 0 0 3.607-1.492l2.194-2.193-1.415-1.415-2.193 2.193Z"
        }
        fill={props.color || theme.palette.grey600}
      />
    </svg>
  );
};

export { Link };
